<template>
  <div class="row">
    <div class="bmQuery col-md-12">
      <bmQuery :mapheight="mapHeight"></bmQuery>
    </div>

    <div class="bannerMid col-md-6" style="padding-right:2px">
      <img src="@/assets/img/banner2.png" alt />
    </div>
    <div class="bannerMid col-md-6" style="padding-left:3px">
      <img src="@/assets/img/banner1.png" alt />
    </div>
    <div style="padding:none;width:100%;display:flex;">
      <div
        style="font-size:14px;font-weight:bold;border-bottom:2px solid #0098fb;color:#0098fb;padding:5px 0;margin:5px 0;"
      >在线服务与出行资讯</div>
    </div>
    <div style="width:100%;display:flex;justify-content:space-between;">
      <!-- <navLink style="width:16%;" :navList="queryOnline"></navLink> -->
      <navLink style="width:16%;" :navList="hyjdInfo"></navLink>
      <navLink style="width:16%;" :navList="bmcx"></navLink>
      <!-- <navLink style="width:16%;" :navList="jtsj"></navLink> -->
      <!-- <navLink style="width:16%;" :navList="tszxfw"></navLink> -->
      <navLink style="width:16%;" :navList="jtzjcx"></navLink>
    </div>

    <!-- <div class="SsNews col-md-4">
      <news-info :title="newsInfoTitle" :url="url1" :route="cxts"></news-info>
    </div>
    <div class="GgNews col-md-4">
      <news-info :title="newsInfoTitle1" :url="url2" :route="hygg"></news-info>
    </div>
    <div class="BmNews col-md-4">
      <news-info :title="newsInfoTitle2" :url="url3" :route="jtsj"></news-info>
    </div>-->
  </div>
</template>

<script>
import { ipconfig } from "@/assets/js/ipconfig.js";
import Axios from "axios";
// import newsInfo from "./news.vue";
import navLink from "./link";
import bmQuery from "@/pages/bmquery/index.vue";
export default {
  data() {
    return {
      // url1: "",
      // url2: "",
      // url3: "",
      // reg: /<[^>]*>|<\/[^>]*>/gm,
      map: null,
      // newsInfoTitle: "出行提示",
      // cxts: "transNews",
      // newsInfoTitle1: "行业公告",
      // hygg: "transNews",
      // newsInfoTitle2: "交通事件",
      // jtsj: "eventMsg",
      mapHeight: "500px",
      queryOnline: {
        title: "在线查询",
        list: [
          {
            name: "清单公示",
            route: "queryOnline",
            type_id: "01"
          },
          {
            name: "执法信息",
            route: "queryOnline",
            type_id: "02"
          },
          {
            name: "办事指南",
            route: "queryOnline",
            type_id: "03"
          },
          {
            name: "服务制度",
            route: "queryOnline",
            type_id: "04"
          }
        ]
      },
      hyjdInfo: {
        title: "行业监督信息",
        list: [
          {
            name: "行政许可指南",
            route: "hyjdMsg"
          },
          {
            name: "行业企业信息查询",
            route: "hyjdMsg"
          }
        ]
      },
      bmcx: {
        title: "便民出行",
        list: [
          {
            name: "公交出行",
            route:"bus"
          },
          {
            name: "铁路出行",
            href:"https://www.12306.cn/index/"
          },
          {
            name: "民航出行",
            href:"https://flights.ctrip.com/actualtime/search"
          },
          {
            name: "大巴出行",
            href:"https://www.bus365.com/city/150600000000.html"
          }
        ]
      },
      jtsj: {
        title: "交通事件",
        list: [
          {
            name: "特殊天气",
            route: "eventMsg",
            type_id: "0201"
          },
          {
            name: "交通事故",
            route: "eventMsg",
            type_id: "0202"
          },
          {
            name: "道路养护与灾毁",
            route: "eventMsg",
            type_id: "0203"
          }
        ]
      },
      tszxfw: {
        title: "投诉咨询与服务",
        list: [
          {
            name: "网上投诉咨询",
            route:"tszxSevers",
            type_id:"01"
          },
          {
            name: "信息跟踪与查询",
            route:"tszxSevers",
            type_id:"02"
          },
          {
            name: "12328热线公示",
            route:"tszxSevers",
            type_id:"03"
          }
        ]
      },
      jtzjcx: {
        title: "交通证件查询",
        list: [
          {
            name: "交通部执法证件查询",
            route:"jtzjQuery",
            type_id:"01"
          },
          {
            name: "自治区执法证件查询",
            route:"jtzjQuery",
            type_id:"02"
          }
        ]
      }
    };
  },
  components: {
    // newsInfo,
    bmQuery,
    navLink
  },
  created() {
    // this.url1 = `http://${ipconfig}/app/isweb/infoservice/getInfoserviceList?con_type_id=0101&innerMS`;
    // this.url2 = `http://${ipconfig}/app/isweb/infoservice/getInfoserviceList?con_type_id=0102&innerMS`;
    // this.url3 = `http://${ipconfig}/app/isweb/infoservice/getInfoserviceList?con_type_id=0201&innerMS`;
  },
  mounted() {}
};
</script>

<style  scoped>
.container-fluid .row {
  padding: 0 5px 0 5px;
}
.bmQuery {
  /* margin-top: 5px; */
  padding: 0 5px;
  margin-bottom: 5px;
  height: 500px;
  overflow: hidden;
  /* background: #4581f8; */
  border: 1px solid #ccc;
}

.bannerMid {
  height: 80px;
  /* background: #f5a055; */
  margin-bottom: 5px;
  /* border: 1px solid red; */
  overflow: hidden;
  padding: 0;
}
.bannerMid > img {
  width: inherit;
}
.SsNews,
.GgNews,
.BmNews {
  padding: 0;
  height: 300px;
  margin-bottom: 5px;
  /* margin-top: 5px; */
}
</style>




// WEBPACK FOOTER //
// src/pages/home/index.vue



// WEBPACK FOOTER //
// src/pages/home/index.vue